<script>
    import CustomPipeline from "./customPipeline.svelte";
</script>

<CustomPipeline />
